<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2022-07-01 18:20:18
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2022-07-22 15:10:52
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\termPage\interaction\interaction.vue
-->
<!-- 患友互动 -->
<template>
    <div class='interaction'>
        <div class="headerCom" style="position:relative">
            <publicBreadCrumb  :breadList="breadList"/> 
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="用户评价" name="first">
                </el-tab-pane>
                <el-tab-pane label="报到记录" name="second"></el-tab-pane>
            </el-tabs>
            <div style="height: 27px;width:27px;border-radius: 50%;background-color: red;color: #fff;font-weight: bold;position: absolute;left: 81px;top: 57px;display: flex;align-items: center;font-size: 12px;justify-content: center;" v-if="number > 0">{{ number > 99 ? '99+' : number }}</div>

        </div>
        <div class="i-container">
            <el-scrollbar style="height: 100%;font-size: 12px;width:100%">
                <ReportedRecord v-if="activeName == 'first'" @upDateNumber='getNumber' />
                <UserReviews v-if="activeName == 'second'" />
            </el-scrollbar>
        </div>
    </div>
</template>

<script>
import { getUnreviewedCount } from './api/index.js'
import ReportedRecord from './components/reportedRecord/index';
import UserReviews from './components/userReviews/index';
export default {
    components:{
        ReportedRecord,
        UserReviews
    },
    data() {
    //这⾥存放数据
        return {
            breadList:[{name:'运营管理'},{name:'患友互动'}],
            activeName:'first',
            number:0,
        };
    },
//监听属性类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//⽅法集合
methods: {
    //点击tabs
    handleClick(tab,event){
    },
    //获取未读消息数
    getNumber(){
        getUnreviewedCount().then(res=>{
            if(res.data < 0){
                res.data = 0
            }
            this.number = res.data
        })
    },
},
//⽣命周期 - 创建完成（可以访问当前this实例）
created() {
    this.getNumber()
},
//⽣命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},
//beforeCreate() {}, //⽣命周期 - 创建之前
//beforeMount() {}, //⽣命周期 - 挂载之前
//beforeUpdate() {}, //⽣命周期 - 更新之前
//updated() {}, //⽣命周期 - 更新之后
//beforeDestroy() {}, //⽣命周期 - 销毁之前
//destroyed() {}, //⽣命周期 - 销毁完成
//activated() {}, //如果页⾯有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped lang="less">
/* @import url(); 引⼊公共css类 */
 @import './interaction.less';
</style>